import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Gallery from './pages/Gallery';
import Features from './pages/Features';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Guides from './pages/Guides';
import Today from './pages/Today';
import Account from './pages/Account';
import Chronicle from './pages/Chronicle';
import Assistant from './pages/Assistant';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './styles/GlobalStyle';
import { useThemeMode } from './theme/useThemeMode';
import { PomodoroProvider } from './pomodoro/PomodoroContext';
import { PageViewTracker } from './components/PageViewTracker';

const router = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

const App: React.FC = () => {
  useEffect(() => {
    document.title = '离了大谱';
  }, []);

  const { theme, preference, cyclePreference } = useThemeMode();

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <BrowserRouter future={router.future}>
        <PomodoroProvider>
          <PageViewTracker />
          <Layout themePreference={preference} onToggleTheme={cyclePreference}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/account" element={<Account />} />
              <Route path="/today" element={<Today />} />
              <Route path="/assistant" element={<Assistant />} />
              <Route path="/chronicle" element={<Chronicle />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guides/:slug" element={<Guides />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/features" element={<Features />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </PomodoroProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App; 
